Apt.fn.make('flash', {
	_construct: function() {
		this.visibleClass = '-is-visible';
	},

	/**
	 * Display flash message
	 *
	 * @param {String} value
	 * @param {String} [status='info']
	 * @param {Object} [options]
	 */
	show: function(value, status, options) {
		var scope = this,
			conf = $.extend({
				html: false,
				timeout: 4500
			}, options),
			$flash = scope.$flash;

		clearTimeout(scope.autohide);

		if (! $flash) {
			scope.$flash = $flash = $('<div class="flash"/>');

			$flash.on('click', function() {
				scope.hide();
			});

			$($._body).prepend($flash);
		} else {
			$flash.removeClass([
				'-success',
				'-warning'
			]);
		}

		if (status) {
			$flash.addClass('-' + status);
		}

		conf.html ?
			$flash.html(value) :
			$flash.text(value);

		requestAnimationFrame(function() {
			$flash.addClass(scope.visibleClass);
		});

		if (scope.visible) {
			var updateClass = '-is-updated';

			$flash.addClass(updateClass)
				.on('transitionend', function() {
					$flash.removeClass(updateClass);
				}, {
					once: true
				});
		}

		scope.visible = true;

		scope.autohide = setTimeout(function() {
			scope.hide();
		}, conf.timeout);
	},

	/**
	 * Show success message
	 *
	 * @param {String} value
	 * @param {Object} [options]
	 */
	success: function(value, options) {
		this.show(value, 'success', options);
	},

	/**
	 * Show error message
	 *
	 * @param {String} value
	 * @param {Object} [options]
	 */
	error: function(value, options) {
		this.show(value, 'warning', options);
	},

	/**
	 * Hide flash container
	 */
	hide: function() {
		var scope = this;

		scope.visible = false;

		if (scope.$flash) {
			scope.$flash.removeClass(scope.visibleClass);
		}
	}
});